import { Box, Tip } from 'grommet';
import useWebSocket, { ReadyState } from 'react-use-websocket';
import { env } from '../../../config/env';
import { Blink } from '../Blink';
import { useUserStore } from '../../../context';

export const WebSocketStatus = () => {
  const userStore = useUserStore();

  const { readyState } = useWebSocket(`${env.apiWsHost}:${env.apiPort}`, {
    protocols: ['Authorization', userStore.token],
    shouldReconnect: () => true,
    reconnectInterval: 3000,
    onError: console.error,
    retryOnError: true,
    share: true,
  });

  return (
    <Box>
      <Tip
        content={
          {
            [ReadyState.CONNECTING]: 'Connecting',
            [ReadyState.OPEN]: 'Connected',
            [ReadyState.CLOSING]: 'Closing',
            [ReadyState.CLOSED]: 'Closed',
            [ReadyState.UNINSTANTIATED]: 'Uninstantiated',
          }[readyState]
        }
      >
        <Box>
          {readyState !== ReadyState.OPEN ? (
            <Blink>
              <Box background="yellow" height="12px" width="12px" round />
            </Blink>
          ) : (
            <Box background="green" height="12px" width="12px" round />
          )}
        </Box>
      </Tip>
    </Box>
  );
};
